import "./ReservaForm.css";

import { useMemo, useState } from "react";

import {
  FaCalendarAlt,
  FaCheckCircle,
  FaEnvelope,
  FaHome,
  FaLock,
  FaPhoneAlt,
  FaUser,
} from "react-icons/fa";

const CORREO_DESTINO = "yannelizaaybar@gmail.com";

const formatearFechaVisita = (fechaISO) => {
  if (!fechaISO) {
    return "No especificada";
  }

  const [anio, mes, dia] = fechaISO.split("-");

  return `${dia}/${mes}/${anio}`;
};

const obtenerFechaEnvio = () => {
  return new Intl.DateTimeFormat("es-DO", {
    timeZone: "America/Santo_Domingo",
    dateStyle: "full",
    timeStyle: "short",
  }).format(new Date());
};

function ReservaForm() {
  const [estadoEnvio, setEstadoEnvio] = useState("inicial");
  const [mensajeEstado, setMensajeEstado] = useState("");

  const fechaMinima = useMemo(() => {
    const fechaActual = new Date();

    fechaActual.setMinutes(
      fechaActual.getMinutes() -
        fechaActual.getTimezoneOffset()
    );

    return fechaActual.toISOString().split("T")[0];
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (estadoEnvio === "enviando") {
      return;
    }

    const formulario = event.currentTarget;
    const datosFormulario = new FormData(formulario);

    const nombre = datosFormulario.get("nombre");
    const telefono = datosFormulario.get("telefono");
    const correo = datosFormulario.get("email");
    const apartamento = datosFormulario.get("apartamento");
    const fecha = datosFormulario.get("fecha");
    const mensaje =
      datosFormulario.get("mensaje") ||
      "Sin mensaje adicional";

    setEstadoEnvio("enviando");
    setMensajeEstado("");

    const fechaVisitaFormateada =
  formatearFechaVisita(fecha);

const fechaEnvio =
  obtenerFechaEnvio();

const datosCorreo = {
  Nombre: nombre,
  Teléfono: telefono,
  Correo: correo,
  Apartamento: apartamento,

  "Fecha preferida de visita":
    fechaVisitaFormateada,

  "Fecha y hora de envío":
    fechaEnvio,

  Mensaje: mensaje,

  _subject:
    `Nueva solicitud de visita - ${apartamento}`,

  _template: "table",
  _captcha: "false",
  _honey:
    datosFormulario.get("_honey") || "",
};

    try {
      const respuesta = await fetch(
        `https://formsubmit.co/ajax/${CORREO_DESTINO}`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },

          body: JSON.stringify(datosCorreo),
        }
      );

      const resultado = await respuesta
        .json()
        .catch(() => null);

      if (
        !respuesta.ok ||
        resultado?.success === false
      ) {
        throw new Error(
          resultado?.message ||
            "No se pudo enviar la solicitud."
        );
      }

      formulario.reset();

      setEstadoEnvio("enviado");

      setMensajeEstado(
        "Tu solicitud fue enviada correctamente. Un asesor se comunicará contigo para confirmar la visita."
      );
    } catch (error) {
      console.error(
        "Error al enviar el formulario:",
        error
      );

      setEstadoEnvio("error");

      setMensajeEstado(
        "No pudimos enviar tu solicitud. Revisa tu conexión e inténtalo nuevamente."
      );
    }
  };

  return (
    <section className="reserva" id="reserva">
      <div className="reserva-container">
        {/* INFORMACIÓN */}

        <div className="reserva-info">
          <span className="reserva-label">
            RESERVA TU VISITA
          </span>

          <h2>
            Conoce el lugar donde comenzará tu próximo
            capítulo.
          </h2>

          <p className="reserva-description">
            Agenda una visita a Residencial YANNA I y
            recibe atención personalizada para conocer
            nuestros apartamentos, facilidades de pago y
            disponibilidad.
          </p>

          <div className="reserva-beneficios">
            <div className="reserva-beneficio">
              <FaCheckCircle />

              <div>
                <strong>
                  Atención personalizada
                </strong>

                <span>
                  Un asesor te acompañará durante todo el
                  proceso.
                </span>
              </div>
            </div>

            <div className="reserva-beneficio">
              <FaCheckCircle />

              <div>
                <strong>
                  Visita sin compromiso
                </strong>

                <span>
                  Conoce el proyecto y aclara todas tus
                  dudas.
                </span>
              </div>
            </div>

            <div className="reserva-beneficio">
              <FaCheckCircle />

              <div>
                <strong>Respuesta rápida</strong>

                <span>
                  Nos comunicaremos contigo lo antes
                  posible.
                </span>
              </div>
            </div>
          </div>

          <div className="reserva-contacto">
            <span>
              ¿Prefieres comunicarte directamente?
            </span>

            <a href="tel:+18299623399">
              <FaPhoneAlt />
              (829) 962-3399
            </a>
          </div>
        </div>

        {/* FORMULARIO */}

        <div className="reserva-form-card">
          <div className="reserva-form-header">
            <span>AGENDA TU VISITA</span>

            <h3>Completa tus datos</h3>

            <p>
              Déjanos tu información y nuestro equipo se
              pondrá en contacto contigo.
            </p>
          </div>

          <form
            className="reserva-form"
            onSubmit={handleSubmit}
          >
            {/* CAMPO OCULTO CONTRA SPAM */}

            <input
              type="text"
              name="_honey"
              className="reserva-honeypot"
              tabIndex="-1"
              autoComplete="off"
              aria-hidden="true"
            />

            <div className="reserva-form-row">
              {/* NOMBRE */}

              <div className="reserva-field">
                <label htmlFor="nombre">
                  Nombre completo
                </label>

                <div className="reserva-input">
                  <FaUser />

                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    placeholder="Escribe tu nombre"
                    autoComplete="name"
                    minLength="3"
                    required
                  />
                </div>
              </div>

              {/* TELÉFONO */}

              <div className="reserva-field">
                <label htmlFor="telefono">
                  Teléfono
                </label>

                <div className="reserva-input">
                  <FaPhoneAlt />

                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    placeholder="(809) 000-0000"
                    autoComplete="tel"
                    minLength="10"
                    required
                  />
                </div>
              </div>
            </div>

            {/* CORREO */}

            <div className="reserva-field">
              <label htmlFor="correo">
                Correo electrónico
              </label>

              <div className="reserva-input">
                <FaEnvelope />

                <input
                  type="email"
                  id="correo"
                  name="email"
                  placeholder="correo@ejemplo.com"
                  autoComplete="email"
                  required
                />
              </div>
            </div>

            <div className="reserva-form-row">
              {/* APARTAMENTO */}

              <div className="reserva-field">
                <label htmlFor="apartamento">
                  Tipo de apartamento
                </label>

                <div className="reserva-input">
                  <FaHome />

                  <select
                    id="apartamento"
                    name="apartamento"
                    defaultValue=""
                    required
                  >
                    <option value="" disabled>
                      Selecciona una opción
                    </option>

                    <option value="Apartamento Tipo A">
                      Tipo A — 144.79 m²
                    </option>

                    <option value="Apartamento Tipo B">
                      Tipo B — 129.67 m²
                    </option>

                    <option value="Apartamento Tipo C">
                      Tipo C — 86.47 m²
                    </option>
                  </select>
                </div>
              </div>

              {/* FECHA */}

              <div className="reserva-field">
                <label htmlFor="fecha">
                  Fecha preferida
                </label>

                <div className="reserva-input">
                  <FaCalendarAlt />

                  <input
                    type="date"
                    id="fecha"
                    name="fecha"
                    min={fechaMinima}
                    required
                  />
                </div>
              </div>
            </div>

            {/* MENSAJE */}

            <div className="reserva-field">
              <label htmlFor="mensaje">
                Mensaje
              </label>

              <textarea
                id="mensaje"
                name="mensaje"
                placeholder="Cuéntanos qué información necesitas..."
                rows="5"
                maxLength="500"
              />
            </div>

            {/* BOTÓN */}

            <button
              type="submit"
              className="reserva-button"
              disabled={estadoEnvio === "enviando"}
            >
              {estadoEnvio === "enviando"
                ? "ENVIANDO SOLICITUD..."
                : "AGENDAR VISITA"}
            </button>

            {/* PRIVACIDAD */}

            <div className="reserva-privacy">
              <FaLock />

              <span>
                Tus datos están protegidos y serán
                utilizados únicamente para contactarte.
              </span>
            </div>

            {/* CONFIRMACIÓN */}

            {estadoEnvio === "enviado" && (
              <div
                className="reserva-estado reserva-estado-exito"
                role="status"
                aria-live="polite"
              >
                <FaCheckCircle />

                <div>
                  <strong>
                    Solicitud enviada correctamente
                  </strong>

                  <span>{mensajeEstado}</span>
                </div>
              </div>
            )}

            {/* ERROR */}

            {estadoEnvio === "error" && (
              <div
                className="reserva-estado reserva-estado-error"
                role="alert"
              >
                <div>
                  <strong>
                    No se pudo enviar
                  </strong>

                  <span>{mensajeEstado}</span>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default ReservaForm;